import React from 'react';
import { Auth } from '@whatsper/texterchat-common';
import { Button } from 'antd';
import { Trans } from 'react-i18next';
import Icon from '@ant-design/icons';
import { ReactComponent as EmailIcon } from '../../../assets/icons/auth/email-icon.svg';
import { ReactComponent as PhoneIcon } from '../../../assets/icons/auth/phone-icon.svg';
import styles from '../Login.module.scss';
const methodIcons = {
    [Auth.Methods.Method.password]: EmailIcon,
    [Auth.Methods.Method.whatsapp_otp]: PhoneIcon,
    [Auth.Methods.Method.totp]: PhoneIcon,
    [Auth.Methods.Method.saml]: PhoneIcon,
};
const availableMethods = [
    Auth.Methods.Method.password,
    Auth.Methods.Method.whatsapp_otp,
    Auth.Methods.Method.totp,
    Auth.Methods.Method.saml,
];
const MethodSelect = ({ authMethods, setAuthMethods }) => {
    const renderMethodTitle = (method) => {
        switch (method) {
            case Auth.Methods.Method.password:
                return React.createElement(Trans, { i18nKey: "loginPasswordMethod" });
            case Auth.Methods.Method.whatsapp_otp:
                return React.createElement(Trans, { i18nKey: "loginWhatsAppOTPMethod" });
            case Auth.Methods.Method.totp:
                return React.createElement(Trans, { i18nKey: "loginTOTPMethod" });
            case Auth.Methods.Method.saml:
                return React.createElement(Trans, { i18nKey: "loginSAMLMethod" });
        }
    };
    return (React.createElement("div", { className: styles.loginMethods }, authMethods
        .filter(method => availableMethods.includes(method))
        .map((method) => (React.createElement(Button, { key: method, type: "default", className: styles.loginFormButton, onClick: () => setAuthMethods([method]) },
        methodIcons[method] && React.createElement(Icon, { className: styles.loginMethodIcon, component: methodIcons[method] }),
        React.createElement("div", null, renderMethodTitle(method)))))));
};
export default MethodSelect;
